export default __webpack_public_path__ + "static/media/goose.0f8d7652.png";